export interface CmmdRuntimeThreadGoal {
  readonly goal: string | null;
}

export function encodeCmmdRuntimeThreadGoalMetadata(
  goal: CmmdRuntimeThreadGoal,
): Readonly<Record<string, unknown>> {
  return { forgeGoal: { schemaVersion: 1, goal: goal.goal } };
}

export function decodeCmmdRuntimeThreadGoalMetadata(
  metadata: Readonly<Record<string, unknown>> | null | undefined,
): CmmdRuntimeThreadGoal | null {
  const value = metadata?.forgeGoal;
  if (typeof value !== "object" || value === null || Array.isArray(value)) return null;
  const record = value as Readonly<Record<string, unknown>>;
  const goal = record.goal;
  if (record.schemaVersion !== 1 || (goal !== null && typeof goal !== "string")) return null;
  if (typeof goal === "string" && goal.trim().length === 0) return null;
  return { goal };
}
